import React from 'react';
import { FormattedMessage } from 'react-intl';
import isDefined from '@afosto/utils/isDefined';
import PaymentActions from './components/PaymentActions';

export const providerFormatter = cell => {
  if (!isDefined(cell)) {
    return '-';
  }
  return (
    <FormattedMessage
      id={`paymentMethods.providers.${cell.toLowerCase()}`}
      description={`Translation of cell value ${cell}`}
      defaultMessage={cell}
    />
  );
};

export const methodFormatter = (cell, row) => {
  if (!isDefined(cell)) {
    return '-';
  }

  return (
    <FormattedMessage
      id={`paymentMethods.${row?.provider_code?.toLowerCase()}.${row.method_code}`}
      description={`Translation of cell value ${cell}`}
      defaultMessage={cell}
    />
  );
};

export const issuerFormatter = (cell, row) =>
  row.providers?.[row.provider_code]?.methods?.[row.method_code]?.issuers[cell]?.name ?? '-';

export const actionsFormatter = (cell, row) => <PaymentActions payment={row} />;
